import React, { useMemo } from 'react';
import styled from 'styled-components';
import cn from 'classnames';
import ArrowLeft from '@crehana/crehana-icons/lib/NewArrowLeft';
import ArrowRight from '@crehana/crehana-icons/lib/NewArrowRight';
import ArrowLeftXS from '@crehana/crehana-icons/lib/ChevronLeft';
import ArrowRightXS from '@crehana/crehana-icons/lib/ChevronRight';
import transition from '../../styles/transition';
import { IconButtonProps } from './types';
import { ICON_BUTTON_TYPES, ICON_BUTTON_XS_TYPES } from './classnames';

const Button = styled.button`
  transition: ${transition('border')};
  & path {
    transition: ${transition('fill')};
  }
`;

const IconButton = React.forwardRef<any, IconButtonProps>(
  (
    {
      children,
      as,
      white,
      darkMode,
      arrow,
      xs,
      customIcon,
      customSize,
      customColor,
      href,
      className = '',
      ...other
    },
    ref,
  ) => {
    const Icon = useMemo(() => {
      if (xs) {
        if (arrow === 'left') {
          return ArrowLeftXS;
        }
        if (arrow === 'right') {
          return ArrowRightXS;
        }
      }
      if (arrow === 'left') {
        return ArrowLeft;
      }
      if (arrow === 'right') {
        return ArrowRight;
      }
      return customIcon;
    }, [arrow, customIcon, xs]);

    const defaultTag: keyof JSX.IntrinsicElements = href ? 'a' : 'button';

    const size = customSize || (xs ? 32 : 24);

    let buttonType: 'default' | 'dark' | 'white' = darkMode
      ? 'dark'
      : 'default';

    if (white) {
      buttonType = 'white';
    }

    return (
      <Button
        ref={ref}
        className={cn(
          xs ? ICON_BUTTON_XS_TYPES[buttonType] : ICON_BUTTON_TYPES[buttonType],
          className,
        )}
        href={href}
        as={as || defaultTag}
        {...other}
      >
        {Icon ? (
          <Icon
            size={size}
            color={customColor}
            ignoreColor={!customColor}
            className={!customColor ? 'fill-current' : undefined}
          />
        ) : (
          children
        )}
      </Button>
    );
  },
);

export default IconButton;
